<!-- components/EditForm.vue -->
<template>
  <div class="edit-form">
    <el-form ref="form" :model="form" label-width="80px" :rules="rules">
      <el-form-item label="用户名" prop="userName">
        <div class="input-group">
          <el-input v-model="form.userName"></el-input>
          <el-button type="primary" @click="forgetAccount" v-show="modelLogin">忘记账号</el-button>
        </div>
      </el-form-item>
      <el-form-item label="密码" prop="passWord">
        <div class="input-group">
          <el-input v-model="form.passWord" show-password></el-input>
          <el-button type="primary" @click="forgetPassword" v-show="modelLogin">忘记密码</el-button>
        </div>
      </el-form-item>
      <el-form-item label="验证码" prop="yzm">
        <el-input v-model="form.yzm" class="yzm" placeholder="请输入图形验证码"></el-input>
        <img :src="captchaImage" alt="验证码" @click="refreshCaptcha" class="captcha-image" />
      </el-form-item>
      <el-form-item label="邮箱" prop="email" v-show="!modelLogin">
        <el-input v-model="form.email"></el-input>
        <el-button type="primary" @click="emailYzmSent" id="buttonEmailYzmSent" :disabled="emailCountdown > 0">{{
          emailCountdown > 0 ? `${emailCountdown}s 后重发` : '发送验证码' }}</el-button>
      </el-form-item>
      <el-form-item label="邮箱验证码" prop="emailyzm" v-show="!modelLogin">
        <el-input v-model="form.emailyzm"></el-input>
      </el-form-item>
      <div class="button-div">
        <el-button type="primary" @click="saveData" v-show="modelLogin">登录</el-button>
        <el-button type="primary" @click="registration" v-show="modelLogin">注册</el-button>
        <el-button type="primary" @click="registrationsaveData" v-show="!modelLogin">提交</el-button>
        <el-button type="primary" @click="backLogin" v-show="!modelLogin">返回登录</el-button>
        <el-button @click="close">关闭</el-button>
      </div>
    </el-form>
    <ModalEI v-if="showModal" v-model:visible="showModal" v-model:titleValue="titleValueForget"
      @close="showModal = false">
      <ForgetPageST @save="onEditSave" @close="showModal = false" v-model:typePage="typePage" />
    </ModalEI>
  </div>
</template>

<script>
import request from '@/utils/request' // 就写这一行

export default {
  name: 'loginPageST',
  props: {},
  data() {
    return {
      form: {
        "userName": "",
        "passWord": "",
        "yzm": "",
        "emailyzm": "",
        "email": ""
      }, // 复制数据避免直接修改 props
      rules: {
        userName: [
          { required: true, message: '请输入您的用户名', trigger: 'blur' },
          { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
        ],
        passWord: [
          { required: true, message: '请输入您的密码', trigger: 'blur' }
        ],
        yzm: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入您的邮箱', trigger: 'blur' }
        ],
        emailyzm: [
          { required: true, message: '请输入系统发送给您的邮箱验证码', trigger: 'blur' }
        ]
      },
      modelLogin: true,
      captchaImage: '',
      captchaImageAn: '',
      isEmailSending: false,
      emailCountdown: 0, // 倒计时秒数（0 表示未开始或已结束）
      countdownInterval: null, // 定时器引用
      showModal: false,
      titleValueForget: "",
      typePage: ""
    }
  },
  methods: {
    async saveData() {
      // 登录账号
      // if (this.form.yzm.trim().toLowerCase() !== this.captchaImageAn.toLowerCase()) {
      //   this.$messageX.xiaoxiti("e", "图形验证码错误");
      //   return;
      // }
      const { userName, passWord, yzm } = this.form; // 假设表单字段为 account 和 password

      if (!userName || !passWord || !yzm) {
        this.$messageX.xiaoxiti("w", "账号、密码、图片验证码不能为空！");
        return;
      }

      const payload = {
        Accounts: userName,
        PassWord: passWord,
        PictureVerify: yzm,
        veriftyID: this.captchaImageAn
      };

      const user_sid = this.$socket.currentSocketId;

      if (!user_sid) {
        this.$messageX.xiaoxiti("e", "网络连接异常，请刷新重试");
        return;
      }
      try {
        const response = await fetch('//www.aboluo.site/api/LoginAccount', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Socket-ID': user_sid
          },
          body: JSON.stringify(payload)
        });

        const data = await response.json();

        if (data.success) {
          const { user, token } = data.response;

          // ✅ 关键：将 token 存入 localStorage 或 Vuex/Pinia
          localStorage.setItem('auth_token', token);
          localStorage.setItem('user_info', JSON.stringify(user));
          localStorage.setItem('current_address', 'ShuaituMorPPage');
          this.$messageX.xiaoxiti("c", "登录成功!");

          // 跳转到首页或仪表盘
          this.$emit('save', {
            user: data.response,
            token: data.response.token,
            success: true
          });
          this.close();

        } else {
          this.$messageX.xiaoxiti("e", data.message || '登录失败');
        }
      } catch (error) {
        console.error('Login error:', error);
        this.$messageX.xiaoxiti("e", "网络错误，请检查连接");
      }
    },
    registration() {
      // 注册
      this.modelLogin = false;
      this.cleanForm();
      this.refreshCaptcha();

    },
    async registrationsaveData() {
      // 表单校验
      const valid = await this.$refs.form.validate();
      if (!valid) return;

      // // 图形验证码校验
      // if (this.form.yzm.trim().toLowerCase() !== this.captchaImageAn.toLowerCase()) {
      //   this.$messageX.xiaoxiti("e", "图形验证码错误");
      //   return;
      // }

      const { userName, passWord, email, emailyzm, yzm } = this.form;
      const payload = {
        Accounts: userName,
        PassWord: passWord,
        MailBox: email,
        emailYZM: emailyzm,
        PictureVerify: yzm,
        veriftyID: this.captchaImageAn
      };

      try {
        const res = await fetch('//www.aboluo.site/api/RegisterAccount', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        // ⭐ 先检查 Content-Type
        const contentType = res.headers.get('content-type');

        // ⭐ 检查 HTTP 状态码
        if (!res.ok) {
          // 状态码不是 2xx
          let errorMessage = `请求失败 (${res.status})`;

          // 尝试解析 JSON 错误信息
          if (contentType && contentType.includes('application/json')) {
            const errorData = await res.json();
            errorMessage = errorData.message || errorMessage;
          } else {
            // 可能是 HTML 错误页
            const text = await res.text();
            console.error('服务器返回 HTML:', text.substring(0, 200));
            errorMessage = `服务器错误 (${res.status})，请查看控制台详情`;
          }

          this.$messageX.xiaoxiti("e", errorMessage);
          return;
        }

        const data = await res.json();
        if (data.success) {
          this.$messageX.xiaoxiti("c", "注册成功！");
          this.backLogin(); // 切回登录页
        } else {
          this.$messageX.xiaoxiti("e", data.message);
        }
      } catch (err) {
        console.log(err);
        this.$messageX.xiaoxiti("e", "网络错误");
      }
    },
    backLogin() {
      // 返回登录
      this.modelLogin = true;
      this.cleanForm();
      this.refreshCaptcha();
    },
    async refreshCaptcha() {
      try {
        // 自动带 Token，自动处理错误
        const res = await request.get('/HuoQuTuPianYanZhenMa', {
        })

        // 如果代码能走到这里，说明 HTTP 200 且 后端 success=true
        this.$messageX.xiaoxiti("c", "图片验证码刷新成功！");
        this.captchaImage = res.captchaImageSrc;
        this.captchaImageAn = res.veriftyID;

      } catch (err) {
        // 如果出错 (HTTP 401/500 或 后端 success=false)，会进这里
        console.log('失败:', err)
        if (err.response.data.message) {
          this.$messageX.xiaoxiti("e", err.response.data.message);
        } else {
          this.initData();
          this.$messageX.xiaoxiti("e", err.message);
        }
      }
    },
    async emailYzmSent() {
      // 校验邮箱格式（可选增强）
      if (this.isEmailSending) return;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.form.email || !emailRegex.test(this.form.email)) {
        this.$messageX.xiaoxiti("w", "请输入有效的邮箱地址");
        return;
      }
      // 如果正在倒计时，直接返回
      if (this.emailCountdown > 0) return;

      this.isEmailSending = true;
      try {
        const email = encodeURIComponent(this.form.email);
        const res = await fetch(`//www.aboluo.site/api/HuoQuEmailYanZhenMa/${email}?t=${Date.now()}`);
        const data = await res.json();
        if (data.success) {
          this.$messageX.xiaoxiti("i", `邮件已发送至【${this.form.email}】`);
          // 可加倒计时禁用按钮（如 60 秒）
          this.startEmailCountdown(120);
        } else {
          this.$messageX.xiaoxiti("e", data.message);
        }
      } finally {
        setTimeout(() => {
          this.isEmailSending = false;
        }, 60000); // 60秒内禁止再次发送
      }
    },
    cleanForm() {
      this.form = {
        "userName": "",
        "passWord": "",
        "yzm": "",
        "emailyzm": "",
        "email": ""
      }
    },
    startEmailCountdown(seconds) {
      // 清除可能存在的旧定时器
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }

      this.emailCountdown = seconds;

      this.countdownInterval = setInterval(() => {
        this.emailCountdown--;
        if (this.emailCountdown <= 0) {
          clearInterval(this.countdownInterval);
          this.countdownInterval = null;
        }
      }, 1000);
    },
    close() {
      this.$emit('close');
    },
    forgetAccount() {
      this.showModal = true;
      this.titleValueForget = "忘记账号";
      this.typePage = "Account";
    },
    forgetPassword() {
      this.showModal = true;
      this.titleValueForget = "忘记密码";
      this.typePage = "Password";
    },
    onEditSave(data) {
      this.titleValueForget = "";
      this.typePage = "";
      if (data.success) {
        if (data.response.forgetType == "Account") {
          confirm("您的用户名为：" + data.response.UserName);
          this.form.userName = data.response.UserName;
        } else {
          this.$messageX.xiaoxiti("c", "密码重置成功！请登录！");
        }
      }
    }
  },
  mounted() {
    this.refreshCaptcha();
    if (localStorage.vipUpdata) {
      this.form.userName = localStorage.vipUpdata;
    }
  },
  beforeUnmount() {
    // console.log("销毁");
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  },
}
</script>

<style scoped>
.edit-form input {
  display: block;
  margin-bottom: 10px;
  padding: 6px;
}

.button-div {
  margin-left: 80px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 18px;
}

.yzm {
  width: 56%;
  height: 48px;
}

.captcha-image {
  height: 46px;
  width: 120px;
  border: 2px solid #ddd;
  border-left: none;
  border-radius: 0 6px 6px 0;
  cursor: pointer;
}

.input-group {
  display: flex;
  align-items: center;
  /* 垂直居中 */
  width: 100%;
  /* 撑满表单项宽度 */
}

.input-group .el-input {
  flex: 1;
  /* 让输入框占据剩余空间 */
}
</style>